export const PaymentsStatusType = {
  Idle: "idle",
  Processing: "processing",
  Completed: "completed",
  Pending: "pending",
  Failed: "failed",
} as const;
export type PaymentsStatusType =
  (typeof PaymentsStatusType)[keyof typeof PaymentsStatusType];
